// extracted by mini-css-extract-plugin
export default {"space":"Layout_space__1qP8r"};